// StacksV2
import React, { useEffect, useState } from "react";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import dayjs from "dayjs";
import "../App.css";

import * as XLSX from "xlsx";
import { APIBaseURL } from "../Config";
import Swal from "sweetalert2";
import { formatToDateTime } from "./main/formatToDateTime";
import { Link } from "react-router-dom";

export default function Stacks() {
  const [Data, setData] = useState([]);

  const [loading, setLoading] = useState(null);
  const [TotalSlot, setTotalSlot] = useState(null);

  const GetData = async () => {
    setLoading(true);
    let url = `${APIBaseURL}/get/yard/stacks`;
  
    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  
  useEffect(() => {
    GetData();
  }, []);



useEffect(() => {
  if (!Data || !Array.isArray(Data)) return;

  const total = Data.reduce((acc, data) => {
    if (
      data.stack_lvl &&
      data.row_start != null &&
      data.row_end != null &&
      data.col_start != null &&
      data.col_end != null
    ) {
      const rows = data.row_end - data.row_start + 1;
      const cols = data.col_end - data.col_start + 1;
      const slots = rows * cols * data.stack_lvl;
      return acc + slots;
    }
    return acc;
  }, 0);

  setTotalSlot(total);
}, [Data]); // make sure this runs when dataList is updated

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h3 className="text-primary">Stacks</h3>
                
                <div className="row">
                  <div className="card">
                    <div className="card-body px-1">
                      <div className="table-responsive text-nowrap">
                      Total Stowage (20ft) : {TotalSlot}
                      <br />
                      Total Stowage (40ft) : {TotalSlot/2}
                        <table className="table table-hover table-striped">
                          <thead>
                            <tr className="table-primary">
                              <td>Serial No.</td>
                              <td>Stack</td>
                              <td>Row</td>
                              <td>Col</td>
                              <td>Height</td>
                              <td>Total Stowage (20ft)</td>
                              <td>Total Stowage (40ft)</td>
                            </tr>
                          </thead>

                          {/* {Array.isArray(containersData) &&
                          containersData.length > 0 ? ( */}
                          <tbody>
                            {Data?.map((data, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                  {/* <a href={`/stackView/${data.name}`}
                                      className="btn btn-label-primary btn-sm mx-1"                                     
                                    > */}
                                      {/* <i className="ri-map-pin-line ri-22px"></i> */}
                                      <span>{i+1}</span>
                                    {/* </a> */}
                                  </td>
                                  <td>
                                    <span>{data.name}</span>
                                  </td>
                                  <td>
                                    <span>{data.row_start}-{data.row_end}</span>
                                  </td>
                                  <td>
                                    <span>{data.col_start}-{data.col_end}</span>
                                  </td>
                                  <td>
                                    <span>{data.stack_lvl ?? 'N/A'}</span>
                                  </td>     
                                  <td>
                                    <span>
                                      {data.stack_lvl
                                        ? `${(data.row_end - data.row_start + 1) * (data.col_end - data.col_start + 1) * data.stack_lvl}`
                                        : 'N/A'
                                        }
                                    </span>
                                  </td>     
                                  <td>
                                    <span>
                                      {data.stack_lvl
                                        ? `${((data.row_end - data.row_start + 1) * (data.col_end - data.col_start + 1) * data.stack_lvl) / 2}`
                                        : 'N/A'}
                                    </span>
                                  </td>             
                                  {/* <td>
                                    <a href={`/stackView/${data.name}`}
                                      className="btn btn-label-primary btn-sm mx-1"                                     
                                    >
                                      <i className="ri-map-pin-line ri-22px"></i>
                                    </a>
                                  </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
}
